import type { SVGProps } from "react";

export interface CloseIconProps extends SVGProps<SVGSVGElement> {
  /** Square edge length in px. Inherits `currentColor` for stroke. Default 16. */
  size?: number;
}

/**
 * Design-neutral close ("×") icon — replaces the legacy `✕` / `✖` glyphs
 * used as dismiss affordances (禁 emoji 铁律, issue #95).
 *
 * A close control is a geometric "X" (two crossed strokes), not a
 * pictographic emoji, so a stroke SVG is the correct design-system-neutral
 * representation. `stroke="currentColor"` so existing color rules apply;
 * callers pass an accessible label on the surrounding button.
 */
export function CloseIcon({ size = 16, ...props }: CloseIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <line x1="6" y1="6" x2="18" y2="18" />
      <line x1="18" y1="6" x2="6" y2="18" />
    </svg>
  );
}
